import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import StudentLayout from '../../components/layouts/StudentLayout';
import { useAuth } from '../../contexts/AuthContext';
import { studentService } from '../../services/studentService';
import FeeStructure from './components/FeeStructure';
import FeeStatement from './components/FeeStatement';
import ProformaInvoice from './components/ProformaInvoice';
import PaymentReceipts from './components/PaymentReceipts';
import FeePayment from '../student-services-portal/components/FeePayment';

export default function StudentFinancePortal() {
  const { tab } = useParams();
  const { user } = useAuth();
  const [student, setStudent] = React.useState(null);
  
  React.useEffect(() => {
    if (user?.id) {
      studentService.getStudentById(user.id).then(setStudent).catch(console.error);
    }
  }, [user?.id]);

  const renderTab = () => {
    switch (tab) {
      case 'fee-payment':
        return <FeePayment studentData={student} onClose={() => window.history.back()} onPaymentComplete={() => {}} />;
      case 'profoma-invoice':
      case 'proforma-invoice':
        return <ProformaInvoice student={student} />;
      case 'fees-statement':
        return <FeeStatement student={student} />;
      case 'payment-receipts':
        return <PaymentReceipts student={student} />;
      case 'fee-structure':
        return <FeeStructure student={student} />;
      default:
        return <Navigate to="/student-finance/fees-statement" replace />;
    }
  };

  return (
    <StudentLayout student={student}>
      {tab !== 'fee-structure' && tab !== 'fees-statement' && tab !== 'profoma-invoice' && tab !== 'proforma-invoice' && tab !== 'payment-receipts' && (
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-900 capitalize">{String(tab).replace(/-/g, ' ')}</h1>
          <p className="text-sm text-slate-500">Student Finance Portal</p>
        </div>
      )}
      {renderTab()}
    </StudentLayout>
  );
}
